module.exports = __webpack_public_path__ + "static/img/gift.ae2c912.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/en/gift.png
// module id = T8HN
// module chunks = 1